import React from "react";

const ReactToggle = ({ toggled, onToggleClick }) => {
  const toggledClass = toggled ? "on" : "";
  const className = "react-toggle " + toggledClass;
  return <div role="button" tabindex="-1" aria-label="Confirm human interaction" className={className} onKeyPress={() => onToggleClick()} onClick={() => onToggleClick()} />;
};

export default ReactToggle;